import React, { useState, useEffect } from 'react';
import {heroTexts, valueTexts, futureTexts} from '../contexts/LangCompany';
import respectImg from '../assets/images/respect.png';
import professionalismImg from '../assets/images/professionalism.png';
import trustImg from '../assets/images/trust.png';
import integrityImg from '../assets/images/integrity.png';
import fairnessImg from '../assets/images/fairness.png';

function CompanyAbout({ lang = 'ko' }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C', // 바탕색 지정
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
        fontFamily: `'Pretendard', 'Noto Sans KR', 'Apple SD Gothic Neo', Arial, sans-serif`
      }}
    >
      {/* Hero Section */}
      <HeroSection lang={lang} isMobile={isMobile} />
      {/* 핵심 가치 Section */}
      <ValueSection lang={lang} isMobile={isMobile} />
      {/* 미래 Section */}
      {/* <FutureSection lang={lang} isMobile={isMobile} /> */}
    </div>
  );
}

function HeroSection({ lang, isMobile }) {
  return (
      <section
        style={{
          width: '100%',
          color: '#29225C',
          padding: isMobile ? '40px 20px 32px 20px' : '72px 0 56px 0',
          textAlign: 'center',
          fontFamily: `'Pretendard', 'Noto Sans KR', 'Apple SD Gothic Neo', Arial, sans-serif`
        }}
      >
        <h1 style={{
          fontSize: isMobile ? '2rem' : '2.8rem',
          fontWeight: 800,
          letterSpacing: '-1.5px',
          marginBottom: 18,
          color: '#fff',
          padding: isMobile ? '0 10px' : '0'
        }}>
          {heroTexts.Title[lang]}
        </h1>
        <p style={{
          fontSize: isMobile ? '1.1rem' : '1.25rem',
          fontWeight: 500,
          opacity: 0.92,
          marginBottom: 0,
          color: '#ffb300',
          padding: isMobile ? '0 10px' : '0'
        }}>
          {heroTexts.SubTitle[lang]}
        </p>
      </section>
  )
}

function ValueSection({ lang, isMobile }) {
  return (
    <section
      style={{
        width: '100%',
        background: '#3a3570',
        color: '#fff',
        padding: isMobile ? '40px 20px 32px 20px' : '56px 0 40px 0',
        fontFamily: `'Pretendard', 'Noto Sans KR', 'Apple SD Gothic Neo', Arial, sans-serif`
      }}
    >
      <h2 style={{
        fontSize: isMobile ? '2rem' : '2.8rem',
        fontWeight: 800,
        color: '#fff',
        marginBottom: isMobile ? 24 : 32,
        letterSpacing: '-1.5px',
        textAlign: 'center',
        padding: isMobile ? '0 10px' : '0'
      }}>
        {valueTexts.Corevalue[lang]}
      </h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: isMobile ? 16 : 28,
          width: '100%',
          maxWidth: 1600,
          margin: '0 auto',
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'stretch',
          padding: isMobile ? '0 10px' : '0'
        }}
      >
        {/* 1번 박스 */}
        <div
          className="value-box"
          style={{
            background: 'rgba(227, 242, 253, 0.2)',
            borderRadius: 14,
            padding: isMobile ? '20px' : '24px',
            color: '#29225C',
            fontWeight: 700,
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            flex: isMobile ? '1 1 100%' : '1 1 286px',
            minWidth: isMobile ? 'auto' : 234,
            maxWidth: isMobile ? 'none' : 286,
            boxSizing: 'border-box',
            marginBottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: isMobile ? '380px' : '380px'
          }}
        >
          <div style={{ marginBottom: 16, color: '#FFFFFF' }}>Professionalism</div>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto'
          }}>
            <img src={professionalismImg} alt="Professionalism" style={{ maxWidth: '100%', height: 'auto', display: 'block', maxHeight: isMobile ? '240px' : 'none' }} />
          </div>
          <div style={{
            marginTop: isMobile ? 24 : 18,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            fontWeight: 500,
            color: '#FFFFFF',
            textAlign: 'center',
            lineHeight: isMobile ? '1.5' : '1.4',
            flex: '1'
          }}>
            {valueTexts.Professionalism[lang]}
          </div>
        </div>
        {/* 2번 박스 */}
        <div
          className="value-box"
          style={{
            background: 'rgba(227, 242, 253, 0.2)',
            borderRadius: 14,
            padding: isMobile ? '20px' : '24px',
            color: '#29225C',
            fontWeight: 700,
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            flex: isMobile ? '1 1 100%' : '1 1 286px',
            minWidth: isMobile ? 'auto' : 234,
            maxWidth: isMobile ? 'none' : 286,
            boxSizing: 'border-box',
            marginBottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: isMobile ? '380px' : '380px'
          }}
        >
          <div style={{ marginBottom: 16, color: '#FFFFFF' }}>Trust</div>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto'
          }}>
            <img src={trustImg} alt="Trust" style={{ maxWidth: '100%', height: 'auto', display: 'block', maxHeight: isMobile ? '240px' : 'none' }} />
          </div>
          <div style={{
            marginTop: isMobile ? 24 : 18,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            fontWeight: 500,
            color: '#FFFFFF',
            textAlign: 'center',
            lineHeight: isMobile ? '1.5' : '1.4',
            flex: '1'
          }}>
            {valueTexts.Trust[lang]}
          </div>
        </div>
        {/* 3번 박스 */}
        <div
          className="value-box"
          style={{
            background: 'rgba(227, 242, 253, 0.2)',
            borderRadius: 14,
            padding: isMobile ? '20px' : '24px',
            color: '#29225C',
            fontWeight: 700,
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            flex: isMobile ? '1 1 100%' : '1 1 286px',
            minWidth: isMobile ? 'auto' : 234,
            maxWidth: isMobile ? 'none' : 286,
            boxSizing: 'border-box',
            marginBottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: isMobile ? '380px' : '380px'
          }}
        >
          <div style={{ marginBottom: 16, color: '#FFFFFF' }}>Integrity</div>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto'
          }}>
            <img src={integrityImg} alt="Integrity" style={{ maxWidth: '100%', height: 'auto', display: 'block', maxHeight: isMobile ? '240px' : 'none' }} />
          </div>
          <div style={{
            marginTop: isMobile ? 24 : 18,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            fontWeight: 500,
            color: '#FFFFFF',
            textAlign: 'center',
            lineHeight: isMobile ? '1.5' : '1.4',
            flex: '1'
          }}>
            {valueTexts.Integrity[lang]}
          </div>
        </div>
        {/* 4번 박스 */}
        <div
          className="value-box"
          style={{
            background: 'rgba(227, 242, 253, 0.2)',
            borderRadius: 14,
            padding: isMobile ? '20px' : '24px',
            color: '#29225C',
            fontWeight: 700,
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            flex: isMobile ? '1 1 100%' : '1 1 286px',
            minWidth: isMobile ? 'auto' : 234,
            maxWidth: isMobile ? 'none' : 286,
            boxSizing: 'border-box',
            marginBottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: isMobile ? '380px' : '380px'
          }}
        >
          <div style={{ marginBottom: 16, color: '#FFFFFF' }}>Respect</div>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto'
          }}>
            <img src={respectImg} alt="Respect" style={{ maxWidth: '100%', height: 'auto', display: 'block', maxHeight: isMobile ? '240px' : 'none' }} />
          </div>
          <div style={{
            marginTop: isMobile ? 24 : 18,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            fontWeight: 500,
            color: '#FFFFFF',
            textAlign: 'center',
            lineHeight: isMobile ? '1.5' : '1.4',
            flex: '1'
          }}>
            {valueTexts.Respect[lang]}
          </div>
        </div>
        {/* 5번 박스 */}
        <div
          className="value-box"
          style={{
            background: 'rgba(227, 242, 253, 0.2)',
            borderRadius: 14,
            padding: isMobile ? '20px' : '24px',
            color: '#29225C',
            fontWeight: 700,
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            flex: isMobile ? '1 1 100%' : '1 1 286px',
            minWidth: isMobile ? 'auto' : 234,
            maxWidth: isMobile ? 'none' : 286,
            boxSizing: 'border-box',
            marginBottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: isMobile ? '380px' : '380px'
          }}
        >
          <div style={{ marginBottom: 16, color: '#FFFFFF' }}>Fairness</div>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto'
          }}>
            <img src={fairnessImg} alt="Fairness" style={{ maxWidth: '100%', height: 'auto', display: 'block', maxHeight: isMobile ? '240px' : 'none' }} />
          </div>
          <div style={{
            marginTop: isMobile ? 24 : 18,
            fontSize: isMobile ? '0.95rem' : '1.05rem',
            fontWeight: 500,
            color: '#FFFFFF',
            textAlign: 'center',
            lineHeight: isMobile ? '1.5' : '1.4',
            flex: '1'
          }}>
            {valueTexts.Fairness[lang]}
          </div>
        </div>
      </div>
      {/* 반응형 처리 */}
      <style>
        {`
          @media (max-width: 1200px) {
            .value-box {
              flex-basis: 33.33% !important;
              max-width: 33.33% !important;
            }
          }
          @media (max-width: 800px) {
            .value-box {
              flex-basis: 50% !important;
              max-width: 50% !important;
            }
          }
          @media (max-width: 600px) {
            .value-box {
              flex-basis: 100% !important;
              max-width: 100% !important;
            }
          }
        `}
      </style>
    </section>
  )
}

function FutureSection({ lang }) {
  return (
      <section
        style={{
          width: '100%',
          color: '#29225C',
          padding: '56px 0 40px 0',
          fontFamily: `'Pretendard', 'Noto Sans KR', 'Apple SD Gothic Neo', Arial, sans-serif`
        }}
      >
        <h2 style={{
          fontSize: '2.8rem',
          fontWeight: 800,
          color: '#fff',
          marginBottom: 24,
          letterSpacing: '-1.5px',
          textAlign: 'center'
        }}>
          {futureTexts.Future[lang]}
        </h2>
        <div style={{
          maxWidth: 900,
          margin: '0 auto',
          fontSize: '1.25rem',
          color: '#e0e0e0',
          textAlign: 'center',
          lineHeight: 1.7
        }}>
          {futureTexts.Text[lang]}
        </div>
      </section>
  )
}

export default CompanyAbout;